<!-- 组件说明 -->
<template>
  <div class="container">
    <div class="con">
      <div class="hd">
        <div class="l">
          <router-link tag="div" to="/" class="logo c-pointer" >
            <img :src="require('@/assets/images/icon_logo.png')" alt="" />
          </router-link>
          <h3  class="c-pointer">账号登录</h3>
        </div>
        <div class="r">
          <div class="server">
            <img :src="require('@/assets/images/icon_server.png')" alt="" />
          </div>
          <div class="hotline">
            <p>免费客服热线</p>
            <h3>{{phone}}</h3>
          </div>
        </div>
      </div>
      <div class="bd">
        <login v-if="type == 1"></login>
        <register v-else></register>
      </div>
    </div>
  </div>
</template>

<script>
import login from "./components/login";
import register from "./components/register";
import { mapState } from "vuex";

export default {
  components: {
    login,
    register,
  },
  data() {
    return {
      type: 1,
    };
  },
  computed: {
    ...mapState('sessionData',['baseInfo']),
    phone(){
      return this.baseInfo.phone
    }
  },
  mounted() {},
  watch:{
    $route: {
      handler: function (t, f) {
        this.type = this.$route.query.type||1  //1为登录   2为注册
      },
      immediate: true,
    },
  }
};
</script>

<style lang='scss' scoped>
.container {
  background: url("../../assets/images/login_bg.png") no-repeat;
  height: 700px;
  width: 100%;
  background-position: center;
  .con {
    position: relative;
  }
}

.hd,
.l,
.r {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.hd {
  margin-top: 48px;
}
.l {
  h3 {
    font-size: 26px;
    color: #333333;
    margin-left: 28px;
  }
}
.r {
  .hotline {
    margin-left: 15px;
    p {
      font-size: 16px;
      color: #808080;
      text-align: right;
    }
    h3 {
      font-size: 16px;
      color: #333333;
      margin-top: 12px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/login/index.vue